import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { ACTIVE_COLOR, PRIMARY_COLOR } from '../../utils/constants';
import useThemeQuery from '../../graphql/queries/toggle-theme';
import { getInitialMode } from '../../utils/utils';

const IOSSwitch = withStyles(theme => ({
  root: {
    width: 47,
    height: 25,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 3,
    '&$checked': {
      transform: 'translateX(23px)',
      color: ACTIVE_COLOR,
      '& + $track': {
        backgroundColor: PRIMARY_COLOR,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 18,
    height: 19,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: '#e5e5e9',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const ChangeThemeSwitch = () => {
  const { client, data } = useThemeQuery();

  useEffect(() => {
    localStorage.setItem("theme", JSON.stringify(getInitialMode()));
  }, []);
  

  const handleChange = event => {
    localStorage.setItem('theme', event.target.checked);
    client.writeData({ data : { theme: event.target.checked }});
  };

  return (
      <FormControlLabel
        control={
          <IOSSwitch
            checked={data && data.theme}
            onChange={handleChange}
            value={data && data.theme}
          />
        }
      />
  );
}

export default ChangeThemeSwitch;